import { EventService } from "../../services/event.service";
export interface Column {
    header: string;
    sortable?: boolean;
    id: string;
}

export interface ChosenModels {
    itemId: number;
    itemName: string;
    itemStartDate: Date; // ISO string (can use `Date` if you plan to parse it)
    itemEndDate: Date;
    itemParentId: number; // Note: this is a string (can be number if needed)
    itemEventTypeId: number; // Same here
}

export enum Type {
    EventType = "E",
    Cabinet = "C",
    Folder = "F",
}

type TypeMapConfig = {
    [K in Type]: {
        service: (dateParam?: number) => any; // Better to type `service` return if possible
        col: Column[] | any;
    };
};

export const TypeMap: TypeMapConfig = {
    E: {
        service: EventService.getAllEventType,
        col: [
            { header: "Name", sortable: true, id: "type_name" },
            { header: "Custom Attributes", sortable: false, id: "custAtt" },
            { header: "Requirements", sortable: false, id: "req" },
            { header: "Cabinets", sortable: false, id: "cabinets" },
            { header: "Folders", sortable: false, id: "folders" },
            { header: "Usage", sortable: false, id: "usage" },
            { header: "Copy", sortable: false, id: "copy" },
            { header: "View in Hierarchy", sortable: false, id: "hierarchy" },
        ],
    },
    C: {
        service: EventService.getNodeTypeCabinet,
        col: [
            { header: "Name", sortable: true, id: "event_name" },
            { header: "Cabinet Type", sortable: true, id: "event_type_name" },
            { header: "Cabinets", sortable: false, id: "cabinets" },
            { header: "Start Date", sortable: true, id: "start_date" },
            { header: "End Date", sortable: true, id: "end_date" },
            { header: "Copy", sortable: false, id: "copy" },
            { header: "View in Hierarchy", sortable: false, id: "hierarchy" },
        ],
    },
    F: {
        service: EventService.getNodeTypeFolder,
        col: [
            { header: "Name", sortable: true, id: "event_name" },
            { header: "Folder Type", sortable: true, id: "event_type_name" },
            { header: "Parent Cabinet", sortable: true, id: "parent_name" },
            { header: "Folders", sortable: false, id: "folders", isDefaultVisible: 1 },
            { header: "Primary Organization", sortable: 1, id: "organization_name" },
            { header: "Start Date", sortable: true, id: "start_date" },
            { header: "End Date", sortable: true, id: "end_date" },
            { header: "Copy", sortable: false, id: "copy", isDefaultVisible: 1 },
            { header: "View in Hierarchy", sortable: false, id: "hierarchy" },
        ],
    },
};

export interface OutputDataI {
    itemName: string;
    type: Type;
    itemTypId: number;
    selectedItems: number[];
    chosenModels: ChosenModels[];
    action: string;
}

export class EventTypeUtil {
    public static getColumns(type: Type): Column[] {
        return TypeMap[type].col;
    }
}
